export default "__VITE_ASSET__DAd4EMDb__"